export default __webpack_public_path__ + "static/media/mitigation-lower-level-drying-fan.7354f8c0.jpg";